import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Card, Row, Col, Input } from 'antd'
import { useGetCryptosQuery } from '../services/cryptoApi'
import millify from 'millify'
import Loader from './Loader'

const Cryptocurrencies = ({ simplified }) => {
  const count = simplified ? 12 : 100;
  const { data: cryptosList, isFetching } = useGetCryptosQuery(count);
  //Now our complete data is stored in this hook, now as we want a small amount of data
  // from this hook we will be using a different hook to catch that data 

  //Usestate Hook
  const [cryptos, setCryptos] = useState(cryptosList?.data?.coins);

  //Usestate Hook
  const [searchTerm, setSearchTerm] = useState('');

  //UseEffect Hook
  useEffect(() => {
    const filterData = cryptosList?.data?.coins.filter((coin) => coin.name.toLowerCase().includes(searchTerm.toLowerCase()))
    setCryptos(filterData)

  }, [cryptosList, searchTerm])
  console.log(cryptos)


  //PreLoader
  if (isFetching) return <Loader/>

  return (
    <>

      {!simplified && (
        <div className="search-crypto">
          <Input placeholder="Search Crypto..." onChange={(e) => setSearchTerm(e.target.value)} ></Input>
        </div> 
      )

      }
      
      <Row gutter={[32, 32]} className="crypto-card-container" >
        {cryptos?.map((currency) => {
          return (

            <Col xs={24} sm={12} lg={6} className="crypto-card" >
              <Link to={`/crypto/${currency.uuid}`}>
                <Card
                  title={`${currency.rank}. ${currency.name}`}
                  extra={<img className='crypto-image' src={currency.iconUrl} />}
                  hoverable>
                  <p>Price: {millify(currency.price)}</p>
                  <p>Market Cap: {millify(currency.marketCap)}</p>
                  <p>Daily Change: {millify(currency.change)}%</p>
                </Card>
              </Link>
            </Col>)
        })}
      </Row>

    </>
  )
}

//Exporting
export default Cryptocurrencies